import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { transformODataResponse } from 'utilities/query';
import userIngredientsComponent from './user-ingredients.component';
import userIngredientsService from './user-ingredients.service';
import userIngredientForm from './user-ingredient-form/user-ingredient-form.module';

export default
  angular.module('components.app.admin.user-ingredients', [
    uiRouter,
    userIngredientForm
  ])
    .component('userIngredients', userIngredientsComponent)
    .service('UserIngredientsService', userIngredientsService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('userIngredients', {
          parent: 'admin',
          url: '/user-ingredients',
          component: 'userIngredients',
          resolve: {
            flex: () => '100',
            layout: () => 'column',
            query: UserIngredientsService => UserIngredientsService.getDefaultQuery(),
            ingredients: (query, UserIngredientsService) =>
              UserIngredientsService.search(query).then(r => transformODataResponse(r))
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/admin/user-ingredients/user-ingredients.module.js